import FJUtil from '../../util/FJUtil';
import $ from 'jquery';
import FJBase from './style/FJBase';

class FJUnderline extends FJBase {
    constructor(props) {
        super(props);

        props = props || {};
        this._name = 'FJTextUnderline';
        this._width = typeof props.width != 'undefined' ? props.width : 2; // 文字下划线偏移
        this._color = typeof props.color != 'undefined' ? props.color : '#7D583D'; // 文字下划线偏移

        this._position = (props && props.position) || 'absolute';
    }

    encode() {
        return {
            name: this._name,
            offset: this._offset,
            color: this._color,
            width: this._width,
        };
    }
    decode(data) {
        this._offset = data.offset;
        this._color = data.color;
        this._width = data.width;
    }
    clone() {
        let object = new FJUnderline();
        object.decode(this);

        return object;
    }
    get name() {
        return this._name;
    }

    set color(color) {
        this._color = color;
    }
    get color() {
        return this._color;
    }

    set width(width) {
        this._width = width;
    }
    get width() {
        return this._width;
    }

    /**
     * 更新文字某一行文字样式
     * @param styleData
     * @param lineIdx
     */
    updateStyle(styleData, lineIdx) {
        if (!this._layer) return;

        let lineLayers = this.getLineLayers();
        let fontSize = parseFloat(styleData.fontSize);

        if (lineIdx < lineLayers.length) {
            let ele = lineLayers[lineIdx];
            $(ele).css({
                ...styleData,
                position: 'relative',
            });

            let height = (fontSize * this._width) / 200 + 1; // 高度最小为1px
            let offset = (fontSize * (this._offset - 50)) / 50;

            let lineDom = document.createElement('i');
            $(lineDom).css({
                display: 'block',
                marginTop: offset + 'px',
                width: '100%',
                height: height + 'px',
                background: this._color,
                zIndex: -1,
            });
            if ($(ele).has('i').length) {
                $(ele).find('i').remove();
            }
            $(ele).append(lineDom);
        }
    }

    /**
     * @desc 更新所有行文字文字样式
     * @param styleData
     */
    updateAllLineStyle(styleData) {
        if (!this._layer) return;

        let lineLayers = this.getLineLayers();
        let fontSize = parseFloat(styleData.fontSize);

        for (let i = 0; i < lineLayers.length; i++) {
            let ele = lineLayers[i];
            $(ele).css({
                ...styleData,
                position: 'relative',
            });

            let height = (fontSize * this._width) / 200 + 1; // 高度最小为1px
            let offset = (fontSize * (this._offset - 50)) / 50;

            let lineDom = document.createElement('i');
            $(lineDom).css({
                display: 'block',
                marginTop: offset + 'px',
                width: '100%',
                height: height + 'px',
                background: this._color,
                zIndex: -1,
            });
            if ($(ele).has('i').length) {
                $(ele).find('i').remove();
            }
            $(ele).append(lineDom);
        }
    }

    isEqual(style) {
        return style.offset === this._offset && style.color === this._color && style.width === this._width;
    }

    clear() {
        if (this._layer && this._layer.parentNode) {
            this._layer.parentNode.removeChild(this._layer);
        }
    }
}

export default FJUnderline;
